








import { defineComponent, PropType, toRefs } from '@nuxtjs/composition-api'
import useCheckbox from '@/composables/use-checkbox'

export default defineComponent({
  model: {
    prop: 'checked',
    event: 'change',
  },
  props: {
    value: {
      type: String as PropType<string | null>,
      default: null,
    },
    label: {
      type: String as PropType<string | null>,
      default: null,
    },
    checked: {
      type: [Array, Boolean],
      default: false,
    },
  },
  setup (props, context) {
    return {
      ...useCheckbox(toRefs(props).checked, context),
    }
  },
})
